import { render, staticRenderFns } from "./AppendixAppendixQrConnectors.vue?vue&type=template&id=32221272&scoped=true"
import script from "./AppendixAppendixQrConnectors.vue?vue&type=script&lang=js"
export * from "./AppendixAppendixQrConnectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32221272",
  null
  
)

export default component.exports